import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../styles/auth.css";
import { useI18n } from "../providers/I18nProvider";
import { API_BASE_URL } from "../config";

const ResetPasswordPage = () => {
  const { t } = useI18n();

  // Login sayfasındaki gibi: ortalanmış kart + arka plan (body.login-body)
  useEffect(() => {
    document.body.classList.add("login-body");
    return () => document.body.classList.remove("login-body");
  }, []);
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    if (!newPassword || !newPassword2 || newPassword !== newPassword2) {
      setStatus({ type: "err", message: t("auth.resetPassword.mismatch") });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ newPassword }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setStatus({ type: "err", message: data?.msg || t("common.genericError") });
        return;
      }
      setStatus({ type: "ok", message: data?.msg || t("auth.resetPassword.success") });
      setTimeout(() => navigate("/login"), 800);
    } catch (err) {
      setStatus({ type: "err", message: err.message || t("common.genericError") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" role="main">
        <div className="auth-brand" aria-hidden="true">
          <div className="auth-brand-inner">
            <img
              className="auth-logo-image"
              src={`${process.env.PUBLIC_URL}/altust_renk.png`}
              alt={t("auth.logoAlt")}
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
        <div className="auth-panel">
          <h2 className="auth-title">{t("auth.resetPassword.title")}</h2>
          <p className="muted" style={{ marginTop: 0 }}>
            {t("auth.resetPassword.subtitle")}
          </p>
          <form className="auth-form" onSubmit={submit}>
            <div className="auth-field">
              <label className="auth-label" htmlFor="reset-password-1">
                {t("account.password.new")}
              </label>
              <input
                id="reset-password-1"
                type="password"
                autoComplete="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="auth-field">
              <label className="auth-label" htmlFor="reset-password-2">
                {t("account.password.new2")}
              </label>
              <input
                id="reset-password-2"
                type="password"
                autoComplete="new-password"
                value={newPassword2}
                onChange={(e) => setNewPassword2(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? t("common.loading") : t("auth.resetPassword.submit")}
            </button>
            {status.message && (
              <div className={status.type === "ok" ? "success-box" : "error-box"}>
                {status.message}
              </div>
            )}
          </form>
          <div style={{ marginTop: 12 }}>
            <Link to="/login">{t("auth.forgotPassword.backToLogin")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;

